/**
 * The caller's billing tier per developer-api.md §5.2 + §8.3.
 *
 * Resolved server-side from the user's active API subscription
 * plan. `API_NO_CREDITS` is the floor state — no active
 * subscription, no concurrency, returns 402 on every
 * credit-consuming call.
 *
 * Wire format: UPPERCASE matches the Kotlin `ApiTier` enum
 * (see `springboot-shared-library/billing/ApiTier.kt`).
 */
export const ApiTier = {
    API_STARTER: 'API_STARTER',
    API_PRO: 'API_PRO',
    API_SCALE: 'API_SCALE',
    API_NO_CREDITS: 'API_NO_CREDITS',
};
